/**
 * Library version.
 * @type {string}
 */
export const version = process.env.VERSION;
